import React from 'react';
import './directHeader.scss';

const DirectHeader = () => {
  return (
    <header>
      <h1 className="header_apk">Odpowiedz na kilka pytań, pozwoli nam to najlepiej dopasować ofertę do Twoich potrzeb</h1>
    </header>
  );
};

export default DirectHeader;
